<div formGroupName="cndt">
    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
        <mat-expansion-panel-header class="mat-panel-header-text">
            <mat-panel-title>検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] ">
                <mat-label>会社</mat-label>
                <mat-select formControlName="companycode" class="disabled-select-color"
                    (selectionChange)="onChangeCompany()">
                    <mat-option [value]="null"></mat-option>
                    <mat-option *ngFor="let type of companyList" [value]="type.value">{{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] ">
                <mat-label>入金地区</mat-label>
                <mat-select formControlName="rcvmnyTantoAreacode" class="disabled-select-color"
                    (selectionChange)="onChangeChiku()">
                    <mat-option [value]="null"></mat-option>
                    <mat-option *ngFor="let type of areaList" [value]="type.value">{{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>口座管理部署</mat-label>
                <mat-select formControlName="kouzaManageBushocode" class="disabled-select-color">
                    <mat-option *ngFor="let type of kouzaManageBushoList" [value]="type.value">{{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>入金締めステータス</mat-label>
                <mat-select formControlName="receivemoneyjimeStatuscode" class="disabled-select-color"
                    (selectionChange)="onChangeStatus()">
                    <mat-option *ngFor="let type of codeConversionMstMap?.get('S300570')"
                        [value]="type.userCode">{{type.hyojiCont}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>入金締め年月日</mat-label>
                <input matInput [matDatepicker]="start" formControlName="rcvmnyClsingYearmonthdate" maxlength="10">
                <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                <mat-datepicker #start></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>入金形態</mat-label>
                <mat-select formControlName="rcvMethodDiv" class="disabled-select-color">
                    <mat-option [value]="null"></mat-option>
                    <mat-option *ngFor="let type of codeConversionMstMap?.get('C00102B')"
                        [value]="type.userCode">{{type.hyojiCont}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="submit" mat-raised-button color="primary" class="btn"
                    [disabled]="searchConditionForm.invalid">検索</button>
            </mat-action-row>
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="button" mat-raised-button color="primary" class="btn"
                    (click)="onClickClear()">クリア</button>
            </mat-action-row>
        </div>
    </mat-expansion-panel>
</div>